
export enum EArielleMessageType {
    PROJECT_DETAILS_COMPLETE = 'PROJECT_DETAILS_COMPLETE',
    EDIT_PROJECT_DETAILS_COMPLETE = 'EDIT_PROJECT_DETAILS_COMPLETE',
    PROJECT_ROADMAP_COMPLETE = 'PROJECT_ROADMAP_COMPLETE',
    BRIEF_TASK_DESCRIPTION_COMPLETE = 'BRIEF_TASK_DESCRIPTION_COMPLETE',
    TASK_TITLE_COMPLETE = 'TASK_TITLE_COMPLETE',
    TASK_DESCRIPTION_COMPLETE = 'TASK_DESCRIPTION_COMPLETE',
    TASK_DEFINITION_OF_DONE_COMPLETE = 'TASK_DEFINITION_OF_DONE_COMPLETE',
    AGENT_STATUS = 'AGENT_STATUS',
    ERROR = 'ERROR',
}

export enum EArielleProcessingType {
    CREATE_PROJECT_DETAILS = 'CREATE_PROJECT_DETAILS',
    EDIT_PROJECT_DETAILS = 'EDIT_PROJECT_DETAILS',
    CREATE_PROJECT_ROADMAP = 'CREATE_PROJECT_ROADMAP',
    CREATE_BRIEF_TASK_DESCRIPTION = 'CREATE_BRIEF_TASK_DESCRIPTION',
    CREATE_TASK_TITLE = 'CREATE_TASK_TITLE',
    CREATE_TASK_DESCRIPTION = 'CREATE_TASK_DESCRIPTION',
    CREATE_TASK_DEFINITION_OF_DONE = 'CREATE_TASK_DEFINITION_OF_DONE',
}

